import { render, staticRenderFns } from "./StudentProgressionEdit.vue?vue&type=template&id=a1006e4c&scoped=true"
import script from "./StudentProgressionEdit.vue?vue&type=script&lang=js"
export * from "./StudentProgressionEdit.vue?vue&type=script&lang=js"
import style0 from "./StudentProgressionEdit.vue?vue&type=style&index=0&id=a1006e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1006e4c",
  null
  
)

export default component.exports